module.exports = __webpack_public_path__ + "img/5_81.e118be37.png";